// FIPS → "County Name, ST" lookup for the frontend.
// Data source: src/data/usCounties.json (3,142 US counties), converted
// from functions/data/usCounties.js. ~148KB raw, ~25KB gzipped — paid for
// the UX win of "Madison County, IL" instead of "county 17119" in tooltips.
//
// The Map is built once at module load (~3k entries), so per-call lookup
// is O(1). Keep the import lazy at the call site if bundle splitting
// matters; today the whole feed renders it inline.

import counties from '../data/usCounties.json';

const FIPS_INDEX = new Map();
for (const c of counties) {
    if (c && c.fips) FIPS_INDEX.set(String(c.fips), c);
}

// Normalize anything that looks like a FIPS code:
//   - already a string like "17119"
//   - number like 17119
//   - string without leading zero on 4-digit state-county pairs like "1119"
function normalizeFips(input) {
    if (input == null) return null;
    const raw = String(input).trim();
    if (!raw) return null;
    if (FIPS_INDEX.has(raw)) return raw;
    // Some sources strip the leading zero — pad to 5 digits.
    const padded = raw.padStart(5, '0');
    if (FIPS_INDEX.has(padded)) return padded;
    return null;
}

/**
 * Return a display-friendly county label, e.g. "Madison County, IL".
 * Independent cities (MD/MO/NV/VA with FIPS county code ≥ 500) omit the suffix.
 * Falls back to "county {fips}" when the FIPS code isn't in the table.
 */
export function getCountyLabel(fips) {
    const key = normalizeFips(fips);
    if (!key) return fips ? `county ${fips}` : null;
    const c = FIPS_INDEX.get(key);
    const isIndependentCity = ['24', '29', '32', '51'].includes(key.slice(0, 2)) &&
        parseInt(key.slice(2), 10) >= 500;
    return isIndependentCity ? `${c.name}, ${c.state}` : `${c.name} County, ${c.state}`;
}

/** Raw record lookup if a caller wants the parts separately. */
export function getCountyRecord(fips) {
    const key = normalizeFips(fips);
    return key ? FIPS_INDEX.get(key) : null;
}
